import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefferalCommissionReportService {



  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/referralCommissionReport";

  url2 = environment.serverAPI4 + "/api/paymentSubscription/referralId";

  searchRefferalCommissionReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }


  RefferalCommissionByUserReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url}/condition/user${queryParams}`, requestBody);
  }

  downloadRefferalCommissionReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getRefferalCommissionReport(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }


  getReferralByRefId(referralId): Observable<Object> {
    return this.http.get(`${this.url2}/${referralId}`);
  }
  
}
